export const PAYER_TABLE_COLUMNS = [
  "companyName",
  "accountNumber",
  "type",
  "updatedTs",
] as const;

export const CELL_WIDTH = {
  companyName: "25%",
  accountNumber: "25%",
  type: "25%",
  updatedTs: "25%",
} as const;
